import React from "react";

export const SimpleLabel = (props: SimpleLabelProps) => {
    const handleEvalAvailable = typeof props.handleEval === "function";
    const evalStyle = (value: string): string => {
        try {
            return props.handleEval(value);
        } catch{
            return value
        }
    }
    let styleProperties: React.CSSProperties = JSON.parse(JSON.stringify(props.cssProperties));
    if (handleEvalAvailable) {
        Object.keys(props.cssProperties).forEach((value: string) => {
            styleProperties[value] = evalStyle(styleProperties[value]);
        })
    }
    return (
        <div style={styleProperties} >{props.translation}{handleEvalAvailable ? props.handleEval(props.value) : props.value}</div>
    );
};

export interface SimpleLabelProps {
    handleEval?(action: string, prepare?: any);
    cssProperties: React.CSSProperties;
    value: string;
    translation?: string;
}